import gql from "graphql-tag";

const sendPhaseInfo = gql`
  mutation sendPhaseInfo(
    $userID: ID!
    $phase1Info: Phase1InfoInput
    $phase2Info: Phase2InfoInput
    $phase3Info: Phase3InfoInput
    $phase4Info: Phase4InfoInput
    $phase5Info: Phase5InfoInput
  ) {
    SendPhaseInfo: sendPhaseInfo(
      userID: $userID
      phase1Info: $phase1Info
      phase2Info: $phase2Info
      phase3Info: $phase3Info
      phase4Info: $phase4Info
      phase5Info: $phase5Info
    ) {
      userID
    }
  }
`;

const uploadAffiliatePendingDocuments = gql`
  mutation uploadAffiliatePendingDocuments(
    $affiliateID: String!
    $data: [InputUpdateDataAffiliate]!
  ) {
    Result: uploadAffiliatePendingDocuments(
      affiliateID: $affiliateID
      data: $data
    ) {
      message
      motive
      statusCode
    }
  }
`;

const acceptPreAffiliateDali = gql`
  mutation acceptPreAffiliateDali($affiliateIDs: [String]) {
    AcceptPreAffiliate: acceptPreAffiliateDali(affiliateIDs: $affiliateIDs) {
      message
      motive
      statusCode
    }
  }
`;

export {
  sendPhaseInfo,
  uploadAffiliatePendingDocuments,
  acceptPreAffiliateDali,
};
